import { Constants, Enum } from '@examdojo/supabase';

export type UserRole = Enum<'user_role'>;

export const USER_ROLE_ORDER = Constants.public.Enums.user_role;
